import * as React from "react";
const SvgCheckmark = props => <svg xmlns="http://www.w3.org/2000/svg" width={30} height={21} viewBox="0 0 30 21" {...props}><path fill="currentColor" d="M28.436 0 10.783 17.839 1.564 8.523 0 10.104 10.783 21 30 1.58z" /></svg>;
export default SvgCheckmark;